function mapBannerClickToAnalytics(data) {
    return {
        event: 'bannerClick',
        ecommerce: {
            click: {
                actionField: { list: data.location },
                products: [{ id: `ban_${data.id}`, name: data.name }],
            },
        },
    };
}

module.exports = mapBannerClickToAnalytics;



// WEBPACK FOOTER //
// ./src/common/dynamiccontent/gtmmapper/banner-click-mapper.js